export const MANAGEMENT_HS_EXCLUSION_TITLE = "si.management.sf.section.info.companies_exclusion.title";

export const MANAGEMENT_HS_EXPORT_TITLE = "si.management.sf.section.info.companies_export.title";
